import store from "@/store"
import { Message } from "element-ui";
import axios from "axios";
import PromiseFinally from "promise.prototype.finally";

import { xCaNonce, xCaSignature, xCaSignatureHeaders } from "./SendRequest";

PromiseFinally.shim();

let axiosSignature = axios.create();
initAxios(axiosSignature, true);

// API网关签名
const ApiSignature = (config) => {
  let accept = config.headers.common["Accept"];
  if (accept == null) {
    accept = "*/*";
    config.headers["Accept"] = accept;
  }
  let date = config.headers["date"];
  if (date == null) {
    // date = new Date().toString()
    // config.headers['X-Ca-Signed-Date'] = date
    date = "";
  }
  let requestMethod = config.method;
  // 获取配置里面Content-Type参与签名
  let contentType =
    config.headers["Content-Type"] ||
    config.headers[requestMethod]["Content-Type"];
  if (contentType == null) {
    contentType = "";
  }
  let { method, url, params } = config;
  // let appKey = "203930474";
  // let appSecret = "ggo1c50Z5SmJrnCQQoy6aIlonhuZu7Xw";
  let appKey = "203866374";
  let appSecret = "Et9j9OntJ0zNRQvFxZoL4N9Y2uPDsoe4";
  method = method.toUpperCase();
  // 测试环境
  // config.headers['X-Ca-Stage'] = 'TEST'
  // console.log('window.__INITIAL_STATE__.CFG', process.env.VUE_APP_ENV)

  if (process.env.VUE_APP_ENV !== "prod") {
    config.headers["X-Ca-Stage"] = "TEST";
  }
  config.headers["X-Ca-Key"] = appKey;
  config.headers["X-Ca-Nonce"] = xCaNonce();
  // 客户端对header进行签名计算
  config.headers["X-Ca-Signature"] = xCaSignature({
    method,
    url,
    accept,
    params,
    date,
    contentType,
    headers: config.headers,
    appSecret,
  });
  config.headers["X-Ca-Signature-Headers"] = xCaSignatureHeaders(
    config.headers
  ); // 服务端API网关参与计算的headers
  return config;
};

function initAxios(axiosObj, isNeedSignature = false) {
  // axios 配置
  axiosObj.defaults.timeout = 5000;
  // 设置请求头默认Content-Type
  axiosObj.defaults.headers.post["Content-Type"] =
    "application/json;charset=UTF-8";
  let axiosDate;
  // http request 拦截器
  axiosObj.interceptors.request.use(
    (config) => {
      config.withCredentials = true; // 开启跨域能力 是否携带cookie
      const axiosConfig = isNeedSignature ? ApiSignature(config) : config;
      return axiosConfig;
    },
    (err) => {
      return Promise.reject(err);
    }
  );

  // http response 拦截器
  axiosObj.interceptors.response.use(
    (response) => {
      // console.log('response interceptor :', response)
      if (response.data.code === 400000701) {
        window.location.reload(false);
        window.location.href = window.location.origin + window.location.pathname.replace('lesson/play/', 'lesson/detail/')
      }
      return response;
    },
    (error) => {
      // console.log('request interceptor error :', error)
      var errorMsg = "";

      if (error.response) {
        switch (error.response.status) {
          case 401:
            // 学院的接口使用的正式环境，与测试环境登陆判断冲突，所以仅在线上环境打开401时跳转登陆
            if (process.env.VUE_APP_ENV === 'prod') {
              const url = encodeURIComponent(window.location.href);
              const loginUrl =
                process.env.VUE_APP_LOGIN_API + '/account/login?from=' + url;
              window.location.href = loginUrl;
            }
            break;
          case 502:
            Message({
              message: "502 网关错误",
              type: "error",
              duration: 3 * 1000,
            });
            store.dispatch("changeLoading", false)
            break;
        }

        if (
          error.response.data &&
          error.response.data.code &&
          error.response.data.message
        ) {
          errorMsg =
            error.response.data &&
            error.response.data.code &&
            error.response.data.message;
          return Promise.reject(error.response.data);
        } else {
          errorMsg =
            error.response.status + " " + error.response.statusText ||
            "系统异常,请稍后再试";
        }
      } else {
        errorMsg = "服务超时,请稍后重试";
      }
      // Message({
      //   type: 'error',
      //   message: errorMsg,
      //   showClose: true,
      //   center: true,
      //   customClass: 'common_tip'
      // })

      let errorData = { code: 0, message: errorMsg };
      return Promise.reject(errorData);
    }
  );
}

export default axiosSignature;
